export function logAuthEvent(level, message, details = {}) {
  const payload = {
    ...details,
    occurredAt: new Date().toISOString(),
  };

  if (level === 'error') {
    console.error(message, payload);
    return;
  }

  if (level === 'warn') {
    console.warn(message, payload);
    return;
  }

  console.info(message, payload);
}
